import { Permission } from '@cims-online/shared'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { useCreateCasTypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { useCASTypesContext } from '../../../../CASTypesContext'
import { CreateEditFormItems } from '../../components/CreateEditFormItems'
import { CreateEditFormItemsValues } from '../../components/CreateEditFormItems/types'
import { CASType } from '../../../../CASTypesContext/types'
import { useProjectContext } from 'context/ProjectContext'

export function useCreate(): CreateHeaderActionOptions<CASType> {
  const { projectId } = useProjectContext()
  const { refetch } = useCASTypesContext()
  const [create] = useCreateCasTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createCASType: {
        type: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    entity: 'Type',
    permission: Permission.CreateCASType,
    modal: {
      type: 'simple',
      body: <CreateEditFormItems />,
      onOk: async ({ name, description }: CreateEditFormItemsValues) => {
        await create({
          variables: { createCASTypeInput: { projectId, name, description } },
        })
        refetch()
      },
    },
  }
}
